import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ResendWithNewEmailV2MutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type ResendWithNewEmailV2Mutation = { __typename?: 'Mutation'; resendWithNewEmailV2: boolean };

export const ResendWithNewEmailV2Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResendWithNewEmailV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resendWithNewEmailV2' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ResendWithNewEmailV2MutationFn = Apollo.MutationFunction<ResendWithNewEmailV2Mutation, ResendWithNewEmailV2MutationVariables>;

/**
 * __useResendWithNewEmailV2Mutation__
 *
 * To run a mutation, you first call `useResendWithNewEmailV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendWithNewEmailV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendWithNewEmailV2Mutation, { data, loading, error }] = useResendWithNewEmailV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendWithNewEmailV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendWithNewEmailV2Mutation, ResendWithNewEmailV2MutationVariables>) {
  return ApolloReactHooks.useMutation<ResendWithNewEmailV2Mutation, ResendWithNewEmailV2MutationVariables>(ResendWithNewEmailV2Document, baseOptions);
}
export type ResendWithNewEmailV2MutationHookResult = ReturnType<typeof useResendWithNewEmailV2Mutation>;
export type ResendWithNewEmailV2MutationResult = Apollo.MutationResult<ResendWithNewEmailV2Mutation>;
export type ResendWithNewEmailV2MutationOptions = Apollo.BaseMutationOptions<ResendWithNewEmailV2Mutation, ResendWithNewEmailV2MutationVariables>;
